export const CACHE_KEYS = {
  all: ['tms-settings'] as const,
  settings: (customerKey?: number) => [...CACHE_KEYS.all, 'settings', customerKey].filter(Boolean),
} as const;
